import { combineReducers } from "redux";

import auth from "./auth";
import city from "./city";
import productTypes from "./productTypes";
import addresses from "./addresses";
import trends from "./trends";
import cart from "./cart";
import featuredProducts from "./featuredProducts";
import gallery from "./gallery";
import videos from "./videos";
import categories from "./categories";
import products from "./products";
import wishlist from "./wishlist";
import currencySelect from "./currencySelect";
import productDetail from "./productDetail";
import accessories from "./accessories";
import { firestoreReducer } from "redux-firestore";
import { firebaseReducer } from "react-redux-firebase";
import payment from "./payment";
import shoppingHistory from "./shoppingHistory";
import checkout from "./checkout";
import departaments from "./departaments";
import municipalities from "./municipalities";

export default combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  auth,
  city,
  productTypes,
  trends,
  cart,
  addresses,
  featuredProducts,
  gallery,
  videos,
  categories,
  products,
  currencySelect,
  productDetail,
  accessories,
  payment,
  wishlist,
  shoppingHistory,
  checkout,
  departaments,
  municipalities,
});
